import { p as proxyCustomElement, H, h, c as Host } from './p-DTTCzifR.js';

const Icon = /*@__PURE__*/ proxyCustomElement(class Icon extends H {
    constructor() {
        super();
        this.__registerHost();
    }
    icon;
    severity;
    class;
    tooltipPos;
    info;
    getSeverityClass() {
        switch (this.severity) {
            case 'primary':
                return 'text-primary-500';
            case 'success':
                return 'text-success-500';
            case 'warning':
                return 'text-warning-500';
            case 'danger':
                return 'text-danger-500';
            case 'info':
                return 'text-info-500';
            default:
                return 'inherit';
        }
    }
    getIconClass() {
        return `icon ic-${this.icon} cursor-pointer !shrink-0`;
    }
    render() {
        return h(Host, { key: 'fb2fed3480089f5fb0962fd829037c2e0c3cda0f', class: this.getIconClass() });
    }
}, [0, "wangs-icon", {
        "icon": [1],
        "severity": [1],
        "class": [1],
        "tooltipPos": [1, "tooltip-pos"],
        "info": [1]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wangs-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "wangs-icon":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, Icon);
            }
            break;
    } });
}

export { Icon as I, defineCustomElement as d };
